import styled from 'styled-components'

const Logo = styled.img`
    width: 100px;
`

export default Logo
